import { getAllUwContexts, registerUwContext } from './uw-context.registry';
import { UwContextDescriptor } from './uw-context.model';
import { naturalHazardsDescriptor } from './contexts/natural-hazards.descriptor';
import { outbuildingDescriptor } from './contexts/outbuilding.descriptor';

const BUILT_IN_UW_CONTEXTS: UwContextDescriptor[] = [naturalHazardsDescriptor, outbuildingDescriptor];

export function registerBuiltInUwContexts(): void {
  const registeredKeys = new Set(getAllUwContexts().map(descriptor => descriptor.key));
  BUILT_IN_UW_CONTEXTS
    .filter(descriptor => !registeredKeys.has(descriptor.key))
    .forEach(descriptor => registerUwContext(descriptor));
}

registerBuiltInUwContexts();
